<template>
    <div class="flex">
        <div class="upload-img-box cursor-point margin-lr-20" v-for="(item, index) in data" :key="`img-${index}`">
            <img class="upload-img" :src="item">
            <div class="icon-label">
                <Icon type="ios-checkmark" size="24" @click.native="handleView(item, index)"></Icon>
                <Icon type="ios-close" size="24" @click.native="handleRemove(item, index)"></Icon>
            </div>
        </div>
        <Upload :ref="name" :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['jpg', 'jpeg', 'png']"
                :headers="{ 'auth': token}"
                :multiple="!isSingle"
                type="drag"
                :action="url"
                :on-format-error="formatError"
        >
            <div class="upload-block">
                <Icon type="md-add" size="20"></Icon>
            </div>
        </Upload>
    </div>
</template>

<script>

export default {
    name: 'UploadImg',
    props: {
        url: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        isSingle: {
            type: Boolean
        },
        name: {
            type: String,
            required: true
        },
        data: {
            type: Array
        }
    },
    methods: {
        handleView(item, index) {
            this.$emit('handleView', item, index)
        },
        handleRemove(item, index) {
            this.$emit('handleRemove', item, index, this.name)
        },
        handleSuccess(res) {
            this.$emit('handleSuccess', res, this.name)
        },
        formatError() {
            this.$Message.warning('当前仅支持jpg,jpeg,png图片')
        }
    }
}
</script>
<style lang="less" scoped>
    .upload-block {
        display: inline-block;
        width: 50px;
        height: 50px;
        line-height: 50px
    }
    .upload-img-box{
        position: relative;
        display: inline-block;
        width: 50px;
        height: 50px;
        margin-right: 10px;
        border: 1px dashed var(--divider-color);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        &:hover{
            border: 1px dashed var(--comp-selected-color);
        }
        .upload-img{
            width: 100%;
            height: 100%;
            border-radius: 5px;
        }
        .icon-label{
            position: absolute;
            right: -17px;
            top: -7px;
            width: 46px;
            height: 26px;
            z-index: 1;
            background: var(--comp-selected-color);
            text-align: center;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            border-radius: 0 0 5px 0;
            -webkit-box-shadow: 0 1px 1px #ccc;
            box-shadow: 0 1px 1px #ccc;
            color: #fff;
            .ivu-icon-ios-checkmark{
                display: block;
                transform: rotate(-45deg);
                line-height: 35px;
            }
            .ivu-icon-ios-close{
                display: none;
                transform: rotate(-45deg);
                line-height: 35px;
            }
            &:hover{
                .ivu-icon-ios-checkmark{
                    display: none;
                }
                .ivu-icon-ios-close{
                    display: block;
                }
            }
        }
    }
    .upload-list {
        position: relative;
        .upload-list-cover {
            display: none;
            position: absolute;
            line-height: 50px;
            width: 100%;
            top: 0;
        }
    }
    .upload-list:hover {
        .upload-list-cover {
            display: block;
        }
    }
</style>
